import Button from 'react-bootstrap/Button';
import { ArrowDown,ArrowUp,ArrowLeft, ArrowRight, HandThumbsDown, HandThumbsUp, XLg, ChevronCompactDown, ChevronCompactUp, ChevronDown, ChevronUp, ZoomIn } from 'react-bootstrap-icons';
const Btn = (props) => {
    return (
    <Button as="b" onClick={props.btnOnClick} variant="" className={" " + props.cssClasses} style={{background:'none', border:'none', padding:0}} >
        {props.img == "ArrowDown" ?
         <ArrowDown />
         : ''
        }
        {props.img == "ArrowUp" ?
         <ArrowUp />
         : ''
        }
        {props.img == "ArrowLeft" ?
         <ArrowLeft />
         : ''
        }
        {props.img == "CaretLeft" ?
         <i className="ti ti-chevron-left" />
         : ''
        }
        {props.img == "ArrowRight" ?
         <ArrowRight />
         : ''
        }
        {props.img == "CaretRight" ?
         <i className="ti ti-chevron-right" />
         : ''
        }
        {props.img == "HandThumbsUp" ?
         <HandThumbsUp />
         : ''
        }
        {props.img == "HandThumbsDown" ?
         <HandThumbsDown />
         : ''
        }
         {props.img == "ChevronCompactDown" ?
         <ChevronCompactDown />
         : ''
        }
        {props.img == "ChevronCompactUp" ?
         <ChevronCompactUp />
         : ''
        }
         {props.img == "ChevronDown" ?
         <ChevronDown />
         : ''
        }
        {props.img == "ChevronUp" ?
         <ChevronUp />
         : ''
        }
        {props.img == "ZoomIn" ?
         <ZoomIn />
         : ''
        }
         {props.img == "X" ?
         <XLg />
         : ''
        }
        {props.btnTitleText}
    </Button>
    );
}

export default Btn; 